// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var VerticalLeftOutlined = function VerticalLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalLeftOutlinedSvg
  }));
};

VerticalLeftOutlined.displayName = 'VerticalLeftOutlined';
export default React.forwardRef(VerticalLeftOutlined);